import request from '@/utils/request'

//判断活动是否开始
export function getAcitivityFlag(query) {
    return request({
        url: '/system/ScoreDetail/getAcitivityFlag',
        method: 'get',
        params: query
    })
}
//获取可抽奖次数
export function getMyLotteryDrawNumber(query) {
    return request({
        url: '/system/main/getMyLotteryDrawNumber',
        method: 'get',
        params: query
    })
}
//获取测评量表
export function getScaleActivityList(query) {
    return request({
        url: '/system/main/getScaleActivityList',
        method: 'get',
        params: query
    })
}

//获取地址信息
export function getMyAddress(query) {
    return request({
        url: '/system/address/getMyAddress',
        method: 'get',
        params: query
    })
}
//新增地址
export function updateAddress(data) {
    return request({
        url: '/system/address',
        method: 'post',
        data
    })
}

//提交测评
export function addScaleActivity(data) {
    return request({
        url: '/system/ScoreDetail/addScaleActivity',
        method: 'post',
        data
    })
}

//获取抽奖数据
export function ltteryDrawing(query) {
    return request({
        url: '/system/main/ltteryDrawing',
        method: 'get',
        params: query
    })
}

//提交答题表单
export function postForm(data) {
    return request({
        url: '/system/questionnaire',
        method: 'post',
        data
    })
}